<template>
  <main-body>
    <div class="d-flex justify-end" style="font-size: small; margin-top: 0px; margin-bottom: 5px">
      총 건수: {{ summary.totalCount }},
      차이 발생 건수: {{ numberFormat(summary.diffCount) }},
    </div>
    <div style="text-align: right; color: red">
      ※ 엔진사용인경우(HP만) M4에 있는 값이 엔진사용량입니다.
    </div>

    <printer-usage-modal :dialog="dialog" :select-printer="selectPrinter"
                         @close-modal="closePrinterUsageModal"
    />
    <sales-modal :dialog="dialog2" :sales-list-click-auto-setting-data="salesData"
                 @close-modal="closeSalesModal"
    />

    <div class="main-con">
      <table class="data-table" style="table-layout: fixed; min-width: 1600px">
        <thead style="z-index: 1">
        <tr>
          <th class="width-percent-4" style="cursor: pointer;" @click="sortOptionChange('rentalcompanyId')">
            업체코드
          </th>
          <th class="width-percent-8" style="cursor: pointer;" @click="sortOptionChange('rentalcompanyName')">
            업체명
          </th>
          <th class="width-percent-4" style="cursor: pointer;" @click="sortOptionChange('accountId')">
            거래처번호
          </th>
          <th class="width-percent-10" style="cursor: pointer;" @click="sortOptionChange('accountName')">
            거래처명
          </th>
          <th class="width-percent-6" style="cursor: pointer;" @click="sortOptionChange('printerContractId')">
            프린터계약 ID
          </th>
          <th class="width-percent-4" style="cursor: pointer;" @click="sortOptionChange('calculationStartdate')">
            계산시작일
          </th>
          <th class="width-percent-6" style="cursor: pointer;" @click="sortOptionChange('monitoringPrinterId')">
            모니터링 프린터 ID
          </th>
          <th class="width-percent-10" style="cursor: pointer;" @click="sortOptionChange('printerModelName')">
            모델 정보
          </th>
          <th class="width-percent-4" style="cursor: pointer;" @click="sortOptionChange('usageStartDate')">
            시작일
          </th>
          <th class="width-percent-4" style="cursor: pointer;" @click="sortOptionChange('usageEndDate')">
            종료일
          </th>
          <th class="width-percent-2" style="cursor: pointer;" @click="sortOptionChange('engineCountYn')">
            A3 두배
          </th>
          <th class="width-percent-2" style="cursor: pointer;" @click="sortOptionChange('engineCountYn')">
            컬러 별도
          </th>
          <th class="width-percent-2" style="cursor: pointer;" @click="sortOptionChange('engineCountYn')">
            엔진 사용
          </th>
          <th class="width-pixel-100">
            매출(기본/추가)
          </th>
          <th style="cursor: pointer; min-width: 320px; width: 320px" @click="sortOptionChange(null)">
            사용량 <br>(월별 / 일별 : 차이)
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in items" :key="index" :style="{cursor: 'pointer', ...markConditionStyle(index)}"
            @click.stop="openPrinterUsageModal(item)"
>
          <template>
            <td class="table-text-center" :title="item.rentalcompanyId">
              {{ item.rentalcompanyId }}
            </td>
            <td :title="item.rentalcompanyName">
              {{ item.rentalcompanyName }}
            </td>
            <td class="table-text-center" :title="item.accountId">
              {{ item.accountId }}
            </td>
            <td class="short-text" :title="item.accountName">
              {{ item.accountName }}
            </td>
            <td class="table-text-center" :title="item.printerContractId">
              {{ item.printerContractId }}
            </td>
            <td class="table-text-center" :title="item.calculationStartdate">
              {{ item.calculationStartdate }}
            </td>
            <td class="table-text-center" :title="item.monitoringPrinterId">
              {{ item.monitoringPrinterId }}
            </td>
            <td class="table-text-left" :title="`${item.printerModelName} (${item.printerSerialNo})`">
              {{ item.printerModelName }}
              <br>
              ({{ item.printerSerialNo }})
            </td>
            <td class="table-text-center">
              {{ item.usageStartDate }}
            </td>
            <td class="table-text-center">
              {{ item.usageEndDate }}
            </td>
            <td class="table-text-center">
              {{ item.a3DoubleCountYn }}
            </td>
            <td class="table-text-center">
              {{ item.colorYn }}
            </td>
            <td class="table-text-center">
              {{ item.engineCountYn }}
            </td>
            <td class="table-text-center">
              {{ item.billingCnt || 0 }} / {{ item.addBillingCnt || 0 }}
              <!--              <v-btn
                              color="primary"
                              dark
                              x-small
                              @click.stop="openSalesModal(item.rentalcompanyId,item.accountName)"
                            >

                            </v-btn>-->
            </td>
            <td>
              <table style="width: 100%; font-size: 8px">
                <tr style="background: #00000000">
                  <th style="min-width: 30px; width: 30px;">
                    M4
                  </th>
                  <td style=" font-size: 10px; min-width: 90px; width: 90px;" class="table-text-right">
                    {{ numberFormat(item.monoA4Cnt) }}
                  </td>
                  <td style=" font-size: 10px; min-width: 90px; width: 90px;" class="table-text-right">
                    {{ numberFormat(item.finalMonoA4 - item.prevMonoA4) }}
                  </td>
                  <td style=" font-size: 10px; min-width: 90px; width: 90px;" class="table-text-right">
                    {{ numberFormat(item.diffMono4) }}
                  </td>
                </tr>
                <tr style="background: #00000000">
                  <th>M3</th>
                  <td class="table-text-right" style=" font-size: 10px;">
                    {{ numberFormat(item.monoA3Cnt) }}
                  </td>
                  <td class="table-text-right" style=" font-size: 10px;">
                    {{ numberFormat(item.finalMonoA3 - item.prevMonoA3) }}
                  </td>
                  <td class="table-text-right" style=" font-size: 10px;">
                    {{ numberFormat(item.diffMono3) }}
                  </td>
                </tr>
                <tr style="background: #00000000">
                  <th>C4</th>
                  <td class="table-text-right" style=" font-size: 10px;">
                    {{ numberFormat(item.colorA4Cnt) }}
                  </td>
                  <td class="table-text-right" style=" font-size: 10px;">
                    {{ numberFormat(item.finalColorA4 - item.prevColorA4) }}
                  </td>
                  <td class="table-text-right" style=" font-size: 10px;">
                    {{ numberFormat(item.diffColor4) }}
                  </td>
                </tr>
                <tr style="background: #00000000">
                  <th>C3</th>
                  <td class="table-text-right" style=" font-size: 10px;">
                    {{ numberFormat(item.colorA3Cnt) }}
                  </td>
                  <td class="table-text-right" style=" font-size: 10px;">
                    {{ numberFormat(item.finalColorA3 - item.prevColorA3) }}
                  </td>
                  <td class="table-text-right" style=" font-size: 10px;">
                    {{ numberFormat(item.diffColor3) }}
                  </td>
                </tr>
              </table>
            </td>
          </template>
        </tr>
        </tbody>
      </table>
    </div>
    <div
      class="infinity_scroll_table_paging"
    >
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="page"
                class="my-4"
                :length="pageLength"
              />
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-show="isLoading" class="loading_wrap">
      <div class="loading" />
      <div class="loading" />
      <div class="loading" />
    </div>
  </main-body>
</template>


<script>
import {PATH} from "@/constants";
import MainBody from "@/components/common/layout/MainBody.vue";
import PrinterUsageModal from "@/views/batch/PrinterUsageModal.vue";
import SalesModal from "@/views/batch/SalesModal.vue";

export default {
  name: "BatchCheckMonthlyUsageComp",
  components: {
    SalesModal,
    MainBody, PrinterUsageModal
  },
  props: {
    searchOptions: {
      type: Object
    },
    identifier: {
      type: Number
    }

  },
  data() {
    return {
      items: [],
      dialog: false,
      dialog2: false,
      dataTotalCount: 0,
      summary: {
        totalCount: 0,
        missCount: 0,
      },
      isLoading: false,
      page: 1,
      isSummaryLoading: false,
      sortOption: {
        sortBy: [],
        sortDesc: [],
      },
      selectPrinter: undefined,
      salesData: {
        rentalcompanyId: undefined,
        companyName: undefined
      },
    }
  },

  computed: {
    pageLength() {
      if (!this.dataTotalCount) return 1
      return Math.ceil(this.dataTotalCount / this.searchOptions.pageSize)
    },
  },
  watch: {
    'searchOptions.pageNumber'(newValue, oldValue) {
      this.page = newValue
    },
    page(newValue, oldValue) {
      this.onLoad(newValue)
    },
    'searchOptions.rentalcompanyId'(newVal) {
      this.onLoad(1)
    },
    identifier() {
      this.sortOption.sortBy = []
      this.sortOption.sortDesc = []
      this.onLoad(1)
    },
  },

  mounted() {
    this.onLoad(1)
  },

  methods: {
    closePrinterUsageModal() {
      this.dialog = false
    },
    openPrinterUsageModal(selectItem) {
      this.selectPrinter = selectItem
      this.dialog = true
    },
    closeSalesModal() {
      this.dialog2 = false
      // this.rentalcompanyId = undefined
    },
    openSalesModal(rentalId, companyName) {
      this.salesData = {
        companyName: companyName,
        rentalcompanyId: !!rentalId ? Number(rentalId) : undefined
      }
      this.dialog2 = true
    },

    markConditionStyle(idx) {
      if (this.items[idx].diffMono4 > 0 || this.items[idx].diffMono3 > 0 || this.items[idx].diffColor4 > 0 || this.items[idx].diffColor3 > 0) {
        return {'backgroundColor': 'yellow'};
      }
    },
    sortOptionChange(e) {
      if (!e) {
        this.sortOption.sortBy.splice(0, this.sortOption.sortBy.length)
        this.sortOption.sortDesc.splice(0, this.sortOption.sortDesc.length)
      } else {
        this.sortOption.sortBy[0] = e
        this.sortOption.sortDesc[0] = this.sortOption.sortDesc[0] === 'true' ? 'false' : 'true'
      }

      this.onLoad(1)

    },

    numberFormat(number) {
      if (!number) return '0'
      return Number(number).toLocaleString()
    },
    onSortChange(option) {
      Object.keys(option).forEach(e => {
        this.sortOption[e] = option[e]
      })
      this.onFilterChanged()
    },
    /**
     * 필터 변경
     */
    onFilterChanged() {
      this.onLoad(1)
    },

    onLoad(pageNumber) {
      this.searchOptions.pageNumber = pageNumber || 1
      this.items.splice(0, this.items.length)
      this.loadData()
      this.loadSummary()
    },
    async loadSummary() {
      this.$request(PATH.BATCH.MONTHLY_CHECK_SUMMARY)
        .setObject(this.searchOptions)
        .catch()
        .enqueue()
        .then(res => {
          this.summary = res
          this.dataTotalCount = res.totalCount
        })
    },
    loadData() {

      this.isLoading = true
      this.$request(PATH.BATCH.MONTHLY_CHECK)
        .setObject({...this.searchOptions, ...this.sortOption})
        .catch()
        .enqueue()
        .then(res => {
          this.items.push(...res.data)
          this.isLoading = false;
        })
        .catch(e => {
          this.isLoading = false;
          alert("조회 실패")
        });
    },


  },
}
</script>

<style scoped>
.main-con {
  position: relative;
  width: 100%;
  height: 92%;
  overflow-y: scroll;
}

.main-con .data-table {
  position: relative;
  width: 100%;
  border-spacing: 0;
}

.main-con .data-table thead {
  position: sticky;
  top: 0;
  background: #ddd;
}

.main-con .data-table thead tr th {
  font-size: 13px;
  word-break: keep-all;
}

.main-con .data-table tbody td {
  padding: 0.15rem;
  text-align: left;
  border: 1px solid #ccc;
  font-size: 11px;
}

.main-con .data-table tbody tr:nth-child(even) {
  background: #f5f5f5;
}

.main-con .data-table tbody tr:hover {
  background: #ddd;
}

.infinity_scroll_table_paging {
  margin-top: 10px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.loading_wrap {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
}

.loading {
  width: 8px;
  height: 8px;
  background: #aaaaaa;
  border-radius: 50%;
  animation: loading-cricle 1.5s infinite ease-in-out;
  display: inline-block;
  margin-right: 8px;
}

.loading:nth-child(2) {
  animation-delay: .5s;
}

.loading:nth-child(3) {
  animation-delay: 1s;
}
</style>
